import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';
import SideBar from '../usercomponents/SideBar';
const apiUrl = process.env.REACT_APP_API_URL;
function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const fetchEnrolledCourses = async () => {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      console.log('Session data:', sessionData);
      if (!sessionData || !sessionData.token || !sessionData.id) {
        console.error('Invalid session data:', sessionData);
        setError('Please login to view courses.');
        setLoading(false);
        return;
      }
      console.log('Fetching courses for student ID:', sessionData.id);
      try {
        const response = await axios.get(`${apiUrl}/api/student/enrolled-courses?nocache=${Date.now()}`, {
          headers: { Authorization: `Bearer ${sessionData.token}` }
        });
        console.log('Courses API response:', response.data);
        if (response.data.success) {
          const validCourses = response.data.courses.filter(course => course.batchid !== undefined && course.batchid !== null);
          console.log('Valid courses with batch IDs:', validCourses.map(c => ({ courseid: c.courseid, batchid: c.batchid })));
          setCourses(validCourses);
          if (!validCourses.length) {
            setError('No valid courses enrolled for this student. Please contact support.');
          }
        } else {
          setError(response.data.message || 'Failed to fetch courses.');
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.response?.data?.message || 'Error fetching courses.');
      } finally {
        setLoading(false);
      }
    };
    fetchEnrolledCourses();
  }, []);
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb mb-24">
            <ul className="flex-align gap-4">
              <li>
                <Link
                  to="/student-dashboard"
                  className="text-gray-200 fw-normal text-15 hover-text-main-600"
                >
                  LMS
                </Link>
              </li>
              <li>
                <span className="text-gray-500 fw-normal d-flex">
                  <i className="ph ph-caret-right" />
                </span>
              </li>
              <li>
                <span className="text-main-600 fw-normal text-15">Courses</span>
              </li>
            </ul>
          </div>
          <div className="card">
            <div className="card-body">
              {loading && <div>Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              {!loading && !error && courses.length === 0 && (
                <div className="alert alert-info">No courses enrolled.</div>
              )}
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-onGoing"
                  role="tabpanel"
                  aria-labelledby="pills-onGoing-tab"
                  tabIndex={0}
                >
                  <div className="row g-20">
                    {courses.map((course) => (
                      <div key={course.courseid} className="col-xxl-3 col-lg-4 col-sm-6">
                        <div className="card border border-gray-100">
                          <div className="card-body p-8">
                            <Link
                              to={`/course-details/${course.batchid}`}
                              className="bg-main-100 rounded-8 overflow-hidden text-center mb-8 h-164 flex-center p-8"
                            >
                              <img
                                src={`${apiUrl}/${course.courseimage}`}
                                alt={course.coursename}
                                style={{ width: '100%', height: 'auto' }}
                              />
                            </Link>
                            <div className="p-8">
                              <span className="text-13 py-2 px-10 rounded-pill bg-success-50 text-success-600 mb-16">
                                IFM Edu Courses
                              </span>
                              <h5 className="mb-0">
                                <Link
                                  to={`/course-details/${course.batchid}`}
                                  className="hover-text-main-600"
                                >
                                  {course.coursename}
                                </Link>
                              </h5>
                              <div className="flex-align gap-8 flex-wrap mt-16">
                                <div>
                                  <span className="text-gray-600 text-13">
                                    {course.coursesummary || 'No summary available'}
                                  </span>
                                </div>
                              </div>
                              <Link
                                to={`/course-details/${course.batchid}`}
                                className="btn btn-outline-main rounded-pill py-9 w-100 mt-24"
                              >
                                View Course
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default Courses;